module.exports = __webpack_public_path__ + "static/media/rin_topbc8a4d7a9c537becbfd50c6d133060ad.webp";